/**
 * Register event listener on document that fires when:
 * * tab change or tab close (in mobile or desktop)
 * * click back / forward button
 * * click any link or perform any other navigation action
 * * soft refresh / hard refresh
 **/
export function onPageChange(cb: () => void) {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      cb();
    }
  });

  window.addEventListener("beforeunload", cb);
}
